import { Injectable, makeStateKey, StateKey } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HistoryService {
  private _storage: string[] = [];

  get storage(): string[] {
    return this._storage;
  }

  set storage(value: string) {
    this._storage.push(value);
    this._storage.slice(0, 20);
  }
}
